import Theme from 'Theme';
import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';
import { TOP_BAR_TOTAL_HEIGHT } from '../../Navigation/Menu/Menu.styles';

const playButtonDimensionSize = Theme.BU * 5;

const smallerSide = Device.width < Device.height ? Device.width : Device.height;

let baseStyles = {
    containerIcon: {},
    playIcon: { width: 28, height: 28 },
    container: {
        paddingHorizontal: Theme.primaryMargin,
        paddingBottom: Theme.primaryPaddingBottom,
        flexDirection: 'column'
    },
    detailContainer: {
        marginHorizontal: -Theme.primaryMargin
    },
    assetDetail: {
        marginTop: Theme.primaryMargin
    },
    imagePreviewContainer: {
        width: '100%',
        height: '100%'
    },
    containerPreviewImage: {
        width: '100%'
    },
    previewImage: {
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Theme.primaryBackgroundColor,
        width: Device.isPhone ? smallerSide : '100%',
        aspectRatio: 16 / 9,
        height: 'auto'
    },
    playButtonContainer: {
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%'
    },
    playButton: {
        height: playButtonDimensionSize,
        width: playButtonDimensionSize
    },
    button: {
        marginVertical: 6
    },
    carousel: {
        marginRight: -Theme.primaryMargin
    },
    infoText: {
        marginTop: 18,
        color: Theme.secondaryTextColor,
        fontSize: Device.isTabletOrWeb ? 16 : 15.5,
        fontFamily: Theme.regularFont
    },
    infoWarningTextContainer: {
        marginTop: 18,
        marginBottom: 18,
        flexDirection: 'row'
        // alignItems: 'center'
    },
    infoWarningText: {
        color: 'white',
        fontSize: Device.isTabletOrWeb ? 18 : 18,
        fontFamily: Theme.regularFont,
        fontWeight: 'bold',
        marginLeft: 0,
        flex: 1
    },
    text: {
        fontSize: Theme.fontSizes.button
    },
    firstBlock: {},
    secondBlock: {},
    recommendedCarousel: {
        marginRight: -20,
        fontSize: 21
    },
    subtitle: {
        fontFamily: Theme.regularFont,
        fontSize: Theme.fontSizes.subtitle,
        color: Theme.secondaryTextColor,
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'stretch',
        marginTop: 6,
        letterSpacing: 0.7
    },
    buttonsContainer: {
        marginVertical: 20
    },
    image: { width: '100%' }
};

if (Device.isTabletOrWeb) {
    baseStyles = {
        ...baseStyles,
        container: {
            ...baseStyles.container,
            paddingTop: 40
        },
        buttonsContainer: {
            ...baseStyles.buttonsContainer,
            marginHorizontal: Theme.primaryMargin
        },
        button: {
            ...baseStyles.button,
            alignSelf: 'stretch'
        },
        assetDetail: {
            marginTop: 10
        },
        detailContainer: {
            ...baseStyles.detailContainer,
            marginVertical: 20,
            marginHorizontal: Theme.primaryMargin,
            flex: 4
        },
        assetDetailContainer: {
            ...baseStyles.assetDetailContainer,
            flexDirection: 'column',
            paddingStart: Theme.primaryMargin,
            flex: 6
        },
        firstBlock: {
            ...baseStyles.firstBlock,
            flexDirection: 'row'
        },
        carousel: {
            ...baseStyles.carousel,
            marginTop: 30
        }
    };
}

if (Device.isWeb) {
    baseStyles = {
        ...baseStyles,
        container: {
            ...baseStyles.container,
            paddingTop: TOP_BAR_TOTAL_HEIGHT,
            transition: 'margin .16s linear'
        },
        detailContainer: {
            flex: 4,
            marginRight: 40
        },
        previewImage: {
            width: '100%',
            height: 259,
            justifyContent: 'center',
            alignItems: 'center'
        },
        firstBlock: {
            flexDirection: 'row'
        },
        assetDetail: {
            marginTop: 0
        },
        recommendedCarousel: {
            width: '100%'
        }
    };
}

export default StyleSheet.create(baseStyles);
